"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TokenNames = exports.abis = void 0;

var _ERC20Detailed = _interopRequireDefault(require("@laminar/flow-protocol-ethereum/artifacts/kovan/abi/ERC20Detailed.json"));

var _FaucetInterface = _interopRequireDefault(require("@laminar/flow-protocol-ethereum/artifacts/kovan/abi/FaucetInterface.json"));

var _MarginFlowProtocol = _interopRequireDefault(require("@laminar/flow-protocol-ethereum/artifacts/kovan/abi/MarginFlowProtocol.json"));

var _MarginFlowProtocolConfig = _interopRequireDefault(require("@laminar/flow-protocol-ethereum/artifacts/kovan/abi/MarginFlowProtocolConfig.json"));

var _MarginFlowProtocolSafety = _interopRequireDefault(require("@laminar/flow-protocol-ethereum/artifacts/kovan/abi/MarginFlowProtocolSafety.json"));

var _MarginLiquidityPoolInterface = _interopRequireDefault(require("@laminar/flow-protocol-ethereum/artifacts/kovan/abi/MarginLiquidityPoolInterface.json"));

var _MarginLiquidityPoolRegistry = _interopRequireDefault(require("@laminar/flow-protocol-ethereum/artifacts/kovan/abi/MarginLiquidityPoolRegistry.json"));

var _MoneyMarket = _interopRequireDefault(require("@laminar/flow-protocol-ethereum/artifacts/kovan/abi/MoneyMarket.json"));

var _PriceOracleInterface = _interopRequireDefault(require("@laminar/flow-protocol-ethereum/artifacts/kovan/abi/PriceOracleInterface.json"));

var _SimplePriceOracle = _interopRequireDefault(require("@laminar/flow-protocol-ethereum/artifacts/kovan/abi/SimplePriceOracle.json"));

var _SyntheticFlowProtocol = _interopRequireDefault(require("@laminar/flow-protocol-ethereum/artifacts/kovan/abi/SyntheticFlowProtocol.json"));

var _SyntheticFlowToken = _interopRequireDefault(require("@laminar/flow-protocol-ethereum/artifacts/kovan/abi/SyntheticFlowToken.json"));

var _SyntheticLiquidityPoolInterface = _interopRequireDefault(require("@laminar/flow-protocol-ethereum/artifacts/kovan/abi/SyntheticLiquidityPoolInterface.json"));

var _deployment = _interopRequireDefault(require("@laminar/flow-protocol-ethereum/artifacts/kovan/deployment.json"));

const abis = ['ERC20', 'FaucetInterface', 'MarginFlowProtocol', 'MarginFlowProtocolConfig', 'MarginFlowProtocolSafety', 'MarginLiquidityPoolInterface', 'MarginLiquidityPoolRegistry', 'MoneyMarket', 'PriceOracleInterface', 'SimplePriceOracle', 'SyntheticFlowProtocol', 'SyntheticFlowToken', 'SyntheticLiquidityPoolInterface'];
exports.abis = abis;
const TokenNames = ['DAI', 'fEUR', 'fJPY', 'fCAD', 'fCHF', 'fGBP', 'fAUD', 'fUSOIL', 'fXAU', 'fBTC', 'fETH'];
exports.TokenNames = TokenNames;
const kovan = {
  networkType: 'kovan',
  abis: {
    ERC20: _ERC20Detailed.default,
    FaucetInterface: _FaucetInterface.default,
    MarginFlowProtocol: _MarginFlowProtocol.default,
    MarginFlowProtocolConfig: _MarginFlowProtocolConfig.default,
    MarginFlowProtocolSafety: _MarginFlowProtocolSafety.default,
    MarginLiquidityPoolInterface: _MarginLiquidityPoolInterface.default,
    MarginLiquidityPoolRegistry: _MarginLiquidityPoolRegistry.default,
    MoneyMarket: _MoneyMarket.default,
    PriceOracleInterface: _PriceOracleInterface.default,
    SimplePriceOracle: _SimplePriceOracle.default,
    SyntheticFlowProtocol: _SyntheticFlowProtocol.default,
    SyntheticFlowToken: _SyntheticFlowToken.default,
    SyntheticLiquidityPoolInterface: _SyntheticLiquidityPoolInterface.default
  },
  addresses: _deployment.default
};
const protocols = {
  kovan
};
var _default = protocols;
exports.default = _default;